import styled from 'styled-components'

import { TextSize, TextWeight, TEXT_SIZE_STYLES, TEXT_WEIGHT_STYLES } from '@/constants/styles/typography/text'

export type TextProps = {
    size?: TextSize
    weight?: TextWeight
    $color?: string
    children?: React.ReactNode
}

export const Text = styled.div.attrs<TextProps>(({ size, weight, $color }) => ({
    className: ['text', size, weight].join(' ')
}))`
    ${({ size }: TextProps) => TEXT_SIZE_STYLES[size!]};
    ${({ weight }: TextProps) => TEXT_WEIGHT_STYLES[weight!]};
    ${({ $color }: TextProps) => $color && `color: ${$color};`};
`

Text.defaultProps = {
    size: 'md',
    weight: 'medium'
}
